import { render, staticRenderFns } from "./AyudaTemaBase.vue?vue&type=template&id=29d97d98&scoped=true"
import script from "./AyudaTemaBase.vue?vue&type=script&lang=js"
export * from "./AyudaTemaBase.vue?vue&type=script&lang=js"
import style0 from "./AyudaTemaBase.vue?vue&type=style&index=0&id=29d97d98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d97d98",
  null
  
)

export default component.exports